import React from 'react';
import '../css/Spotlight.css';
import { spotlight } from '../assets/spotlight';

class Spotlight extends React.Component {
  render() {
    return (
      <div className='spotlight__wrapper'>
        <h2 className='spotlight__title'>In de kijker</h2>
        <div className='spotlight__content--wrapper'>
          <div className='content__image--wrapper'>
            <div className='content__image--overlay' />
            <img src={spotlight.imagePath} alt="spotlight" className='' />
          </div>
          <div className='content__text--wrapper'>
            <h3>{spotlight.title}</h3>
            {spotlight.innerHtml}
          </div>
        </div>
      </div>
    )
  }
}

export default Spotlight;
